const translations = {
  "en": {
    "%{var0} Balance sheet": "%{var0} Balance sheet",
    "%{var0} Cash flow": "%{var0} Cash flow",
    "%{var0} Income": "%{var0} Income",
    "Annual": "Annual",
    "Balance sheet": "Balance sheet",
    "Cash flow": "Cash flow",
    "Financials in millions USD. Fiscal year is February - January.": "Financials in millions USD. Fiscal year is February - January.",
    "Income": "Income",
    "Quarterly": "Quarterly"
  },
  "zh-tw": {
    "%{var0} Balance sheet": "%{var0} 資產負債表",
    "%{var0} Cash flow": "%{var0} 現金流量",
    "%{var0} Income": "%{var0} 損益表",
    "Annual": "年度",
    "Balance sheet": "資產負債表",
    "Cash flow": "現金流量",
    "Financials in millions USD. Fiscal year is February - January.": "財務資料以百萬美元計。會計年度為二月至一月。",
    "Income": "損益表",
    "Quarterly": "每季"
  }
};

export default translations;
